"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 16.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), _react.default.createElement("circle", {
  cx: "9",
  cy: "12",
  r: "1"
}), _react.default.createElement("circle", {
  cx: "13",
  cy: "8",
  r: "1"
}), _react.default.createElement("circle", {
  cx: "13",
  cy: "16",
  r: "1"
}), _react.default.createElement("path", {
  d: "M17 12.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), _react.default.createElement("circle", {
  cx: "13",
  cy: "12",
  r: "1"
}), _react.default.createElement("path", {
  d: "M3 3h18v2H3z"
}), _react.default.createElement("circle", {
  cx: "5",
  cy: "8",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "5",
  cy: "12",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "5",
  cy: "16",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M17 8.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), _react.default.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "1"
}), _react.default.createElement("circle", {
  cx: "9",
  cy: "8",
  r: "1"
}), _react.default.createElement("path", {
  d: "M3 19h18v2H3z"
}))), 'BlurLinearTwoTone');

exports.default = _default;